'use client';

import { useEffect } from 'react';

/**
 * Restores the browser's native edge gestures (macOS trackpad swipe-back /
 * forward, rubber-band bounce) while mounted by flagging <html
 * data-native-overscroll>. The root layout pins <html>/<body> with
 * `overscroll-none` for the workspace shell; public pages that scroll inside
 * their own container (docs, legal, download, start) render this so the
 * gesture chains through to the browser instead of being swallowed.
 *
 * Marketing pages don't need it: `data-marketing-scroll` (MarketingShell)
 * already sets `overscroll-behavior: auto` in styles/marketing.css.
 */
export const NativeOverscroll = () => {
	useEffect(() => {
		const html = document.documentElement;
		html.setAttribute('data-native-overscroll', '');
		return () => html.removeAttribute('data-native-overscroll');
	}, []);
	return null;
};
